var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShippingHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.739,
    height: 48.037,
    viewBox: "0 0 88.739 48.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verzenden",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M44.7,44.268a7.6,7.6,0,1,1,7.6-7.6A7.6,7.6,0,0,1,44.7,44.268Zm0-12.431a4.829,4.829,0,1,0,4.823,4.829A4.829,4.829,0,0,0,44.7,31.837Z",
    transform: "translate(31.654 3.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M23.036,44.268a7.6,7.6,0,1,1,7.595-7.6A7.6,7.6,0,0,1,23.036,44.268Zm0-12.431a4.829,4.829,0,1,0,4.822,4.829A4.829,4.829,0,0,0,23.036,31.837Z",
    transform: "translate(13.261 3.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M56.852,47.5H53.06a1.387,1.387,0,0,1,0-2.773h3.4V37.378a5.843,5.843,0,0,0-.74-2.84L48.215,21.081a.74.74,0,0,0-.645-.379H37.34V44.736h3.3a1.387,1.387,0,0,1,0,2.773H35.954a1.387,1.387,0,0,1-1.387-1.387V19.316a1.387,1.387,0,0,1,1.387-1.387H47.569a3.513,3.513,0,0,1,3.069,1.8l7.5,13.459a8.619,8.619,0,0,1,1.089,4.189v7.746A2.383,2.383,0,0,1,56.852,47.5Z",
    transform: "translate(29.508 -5.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M22.923,40.095H9.629a1.387,1.387,0,0,1-1.387-1.387V28.045a1.387,1.387,0,1,1,2.773,0v9.277H22.923a1.387,1.387,0,0,1,0,2.773Z",
    transform: "translate(7.163 1.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M9.629,30.295a1.387,1.387,0,0,1-1.387-1.387V19.6a1.387,1.387,0,0,1,2.773,0v9.316a1.387,1.387,0,0,1-1.387,1.381Z",
    transform: "translate(7.163 -5.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M58.3,53.126H35.341a1.387,1.387,0,1,1,0-2.773h21.57V14.078h-45.9v5.711a1.387,1.387,0,0,1-2.773,0V13.823a2.522,2.522,0,0,1,2.52-2.518h46.4a2.522,2.522,0,0,1,2.518,2.518V51.74A1.387,1.387,0,0,1,58.3,53.126Z",
    transform: "translate(7.163 -11.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M20.673,29.431H3.075a1.387,1.387,0,1,1,0-2.773h17.6a1.387,1.387,0,1,1,0,2.773Z",
    transform: "translate(1.601 1.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M31.453,26.02H6.9a1.387,1.387,0,1,1,0-2.773H31.453a1.387,1.387,0,0,1,0,2.773Z",
    transform: "translate(4.844 -1.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M10.885,22.06H1.3a1.387,1.387,0,1,1,0-2.773h9.59a1.387,1.387,0,1,1,0,2.773Z",
    transform: "translate(0.091 -4.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M22.571,17.917H5.644a1.387,1.387,0,0,1,0-2.773H22.571a1.387,1.387,0,0,1,0,2.773Z",
    transform: "translate(3.781 -8.047)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingHub);
export default __webpack_public_path__ + "static/media/ShippingHub.a4a2ab75d32ea4ee3195c8cc3b3e25a9.svg";
export { ForwardRef as ReactComponent };